// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <h2 id="allows-internal-va-users-to-manage-veterans%E2%80%99-decision-review-requests-per-the-appeals-modernization-act-(ama)-or-the-legacy-benefits-appeals-process.">Allows internal VA users to manage Veterans’ decision review requests per the <a href="https://benefits.va.gov/benefits/appeals.asp">Appeals Modernization Act (AMA)</a> or the legacy benefits appeals process.</h2>
      <p>Allows you to submit, manage, or check the status of decision reviews (appeals) related to VA benefits claims. <Link to="/release-notes/appeals">Review the latest release notes</Link>.</p>
    </div>
  );
};

export default MarkdownComponent;
